<template>
    <div class="tooltipElement">
        <div
            class="setElement"
            :class="isActive ? 'active tooltipHide' : ''"
        >
            <div
                class="setElement_trigger"
                @click="isActive = !isActive"
            >
                <inline-svg
                    :src="position_icon"
                    :fill="isActive ? `#${this.getSessionDetails.editorSetup.colors.primaryColor}` : '#707070'"
                />
            </div>
            <div class="setElement_container">
                <div
                    class="setElement_form-group"
                >
                    <span>X</span>
                    <input
                        id="setElementX"
                        v-model.number="setElementX"
                        type="number"
                        name="setElementX"
                        @input="setElement('X')"
                        ref="setElementX"
                    />
                    <span>px</span>
                </div>
                <div
                    class="setElement_form-group"
                >
                    <span>Y</span>
                    <input
                        id="setElementY"
                        v-model.number="setElementY"
                        type="number"
                        name="setElementY"
                        @input="setElement('Y')"
                        ref="setElementY"
                    />
                    <span>px</span>
                </div>
                <div class="setElementSize_container" v-if="getActiveElement.type !== 'QR_CODE_ELEMENT'">
                    <div
                        class="setElement_form-group"
                    >
                        <span>{{ $t('editorSceneElementOptionsWidth') }}</span>
                        <input
                            id="setElementWidth"
                            v-model.number="setElementWidth"
                            type="number"
                            name="setElementWidth"
                            @input="setElement('Width')"
                            ref="setElementWidth"
                        />
                        <span>px</span>
                    </div>
                    <div
                        class="setElement_form-group"
                    >
                        <span>{{ $t('editorSceneElementOptionsHeight') }}</span>
                        <input
                            id="setElementHeight"
                            v-model.number="setElementHeight"
                            type="number"
                            name="setElementHeight"
                            @input="setElement('Height')"
                            ref="setElementHeight"
                        />
                        <span>px</span>
                    </div>
                </div>
            </div>
        </div>
        <Tooltip :tooltipText="`${ $t('editorSceneElementOptionsSetPosition') }`" />
    </div>
    
</template>

<script>
    import { mapGetters } from 'vuex';
    import Tooltip from '@/components/Global/Tooltip.vue';
    import position_icon from '@/assets/icons/position.svg';

    export default {
        data() {
            return {
                setElementX: 0,
                setElementY: 0,
                setElementWidth: null,
                setElementHeight: null,
                position_icon,
                isActive: false
            }
        },
        methods: {
            setElementBasics() {
                this.setElementX = this.getActiveElement.frame.translate[0];
                this.setElementY = this.getActiveElement.frame.translate[1];

                if (this.getActiveElement.type === 'QR_CODE_ELEMENT') {
                    this.setElementWidth = this.getActiveElement.width;
                    this.setElementHeight = this.getActiveElement.height;
                } else {
                    this.setElementWidth = this.getActiveElement.endValues.width;
                    this.setElementHeight = this.getActiveElement.endValues.height;
                }
                
            },
            setElement(value) {
                this.$nextTick(() => {
                    this.$refs[`setElement${value}`].focus();
                });

                let frame;

                if (value === 'Width' || value === 'Height') {
                    frame = {
                        ...this.getActiveElement.frame,
                        scale: [1, 1],
                        translate: [this.setElementX, this.setElementY]
                    }
                } else {
                    frame = {
                        ...this.getActiveElement.frame,
                        translate: [this.setElementX, this.setElementY]
                    }
                }

                

                this.$store.dispatch('UPDATE_ELEMENT', {
                    frame,
                    width: this.setElementWidth,
                    height: this.setElementHeight,
                    endValues: {
                        width: this.setElementWidth,
                        height: this.setElementHeight
                    },
                    webSizeMM: {
                        ...this.getActiveElement.webSizeMM,
                        translate: [this.setElementX * 0.084667, this.setElementY * 0.084667],
                        width: this.setElementWidth * 0.084667,
                        height: this.setElementHeight * 0.084667
                    }
                })
            }
        },
        watch: {
            getActiveElement: {
                deep: true,
                handler() {
                    this.setElementBasics();
                }
            }
        },
        computed: {
            ...mapGetters([
                'getActiveElement',
                'getSessionDetails'
            ])
        },
        mounted() {
            this.setElementBasics();
        },
        components: {
            Tooltip
        }
    }
</script>

<style lang="scss" scoped>
    .setElement {
        position: relative;

        .setElement_trigger {
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 3px;
            border-right: 1px solid #D4D4D4;
        }

        .setElement_container {
            display: none;
            padding: 15px 15px 5px 15px;
            background-color: #f5f5f5;
            box-shadow: 5px 8px 10px 0px #D4D4D4;
            position: absolute;
            width: 115px;
            top: 34px;
        }

        &.active {
            .setElement_container {
                display: block;
            }
        }
        &:hover {
            svg {
                fill: var(--primary-color);
            }
        }

        &_form-group {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #707070;
            margin: 0 0 10px 0;

            input {
                padding: 6px;
                width: 65px;
                box-sizing: border-box;
                border-radius: 3px;
                border: 1px solid #ffffff;
            }
        }
    }
</style>